import { Button, Typography } from '@navi/web-ui/lib/primitives';
import CopyToClipboardIcon from '@cp/src/assets/icons/CopyToClipboardIcon';
import CaseCountTooltip from '../components/CaseCountTooltip';
import styles from './index.module.scss';

interface EditConfigurationDrawerFooterProps {
  onClose: () => void;
  onSubmit: () => void;
  onQueryCopy: () => void;
  isSubmitButtonDisabled: boolean;
  isDirtyField: boolean;
  onCancelClick: () => void;
}

const EditConfigurationDrawerFooter = (props: EditConfigurationDrawerFooterProps) => {
  const { onClose, onSubmit, onQueryCopy, isSubmitButtonDisabled, isDirtyField, onCancelClick } =
    props;
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between px-4 pb-2">
        <div className="flex items-center gap-2">
          <Typography variant="h4" color="var(--navi-color-gray-c2)">
            Query
          </Typography>
          <CaseCountTooltip />
        </div>
        <div className="flex items-center gap-[6px]">
          <Typography variant="h4" color={'var(--navi-color-gray-c2)'}>
            Copy
          </Typography>
          <CopyToClipboardIcon width={20} height={20} onClick={onQueryCopy} />
        </div>
      </div>
      <div className={styles.horizontalLine} />

      <div className="flex gap-2 pt-5 px-4">
        <Button variant="secondary" onClick={onCancelClick} size="medium" className="flex-1">
          Cancel
        </Button>
        <Button
          variant="primary"
          type="submit"
          size="medium"
          onClick={onSubmit}
          className="flex-1"
          disabled={isSubmitButtonDisabled || !isDirtyField}
        >
          Save changes
        </Button>
      </div>
    </div>
  );
};

export default EditConfigurationDrawerFooter;
